import { topicsItems } from '@/mocks/homeData';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  down: 'ri-arrow-down-line text-secondary-500',
  hot: 'ri-fire-line text-accent-500',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-hashtag"></i>
            话题广场
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">热门话题</h2>
          <p className="text-foreground-600 text-sm">当前最受关注的热议话题，点击探索更多内容</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {topicsItems.map((item, i) => (
              <a
                key={i}
                href="#cards"
                className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full border border-secondary-200 hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 group cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                  #{item.name}
                </span>
                <span className="text-xs text-foreground-400 flex items-center gap-0.5">
                  <i className={`text-xs ${trendIcons[item.trend] || ''}`}></i>
                  {item.heat}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}